var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHasura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FF4D61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 76.3453C59.9672 76.3453 70.4792 65.8333 70.4792 52.8662C70.4792 39.899 59.9672 29.387 47 29.387C34.0328 29.387 23.5209 39.899 23.5209 52.8662C23.5209 65.8333 34.0328 76.3453 47 76.3453Z",
    fill: "#FF4D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3467 59.9262L47.565 42.7934C46.7913 41.284 44.937 40.6857 43.4233 41.46C41.9136 42.2357 41.3153 44.0894 42.089 45.5994L45.7559 52.7482L39.1927 59.2931C37.9884 60.4945 37.9884 62.4414 39.1862 63.6451C39.7876 64.2462 40.5753 64.5488 41.363 64.5488C42.1507 64.5488 42.9353 64.2463 43.5362 63.6505L48.7002 58.498L50.8716 62.7325C51.4173 63.796 52.491 64.4074 53.6127 64.4074C54.083 64.4074 54.5619 64.298 55.0122 64.0677C56.5227 63.2937 57.1207 61.44 56.3467 59.9262Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1586 12.21C66.4075 13.3223 69.3649 23.467 62.3468 29.4507C57.918 26.5783 52.6395 24.8945 46.9645 24.8945C41.3068 24.8945 36.0424 26.572 31.6203 29.4251C24.6441 23.4406 27.5877 13.3223 25.8441 12.21C22.9846 10.3862 17.609 20.8616 18.0226 27.5157C18.2454 31.0737 19.1919 36.2865 21.7771 40.3252C19.8497 44.1143 18.7399 48.3754 18.7399 52.8987C18.7399 68.3443 31.4006 80.9109 46.9648 80.9109C62.5321 80.9109 75.1899 68.3448 75.1899 52.8987C75.1899 48.4021 74.09 44.1625 72.1839 40.3923C74.8004 36.3419 75.7541 31.0917 75.9772 27.5157C76.3931 20.8616 71.0143 10.386 68.1586 12.21ZM46.9645 74.7317C34.8355 74.7317 24.9609 64.9411 24.9609 52.8984C24.9609 40.8614 34.8355 31.0668 46.9645 31.0668C59.1007 31.0668 68.9693 40.8614 68.9693 52.8984C68.9693 64.9417 59.1007 74.7317 46.9645 74.7317Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasura);
export default __webpack_public_path__ + "static/media/hasura.e6fb2a5a14818f3a703587bc483dc54e.svg";
export { ForwardRef as ReactComponent };